import { sendMQTTMessage, parseMqttResult } from './helper'
import { IMQTTRes } from './type'
import { ISmbConfig, ISmbStatus, ISambaUser } from '@remote/type/gx'

// 获取磁盘名称
interface IDiskNameInfo {
  ori_name?: string
  disk_name: string
  path: string
}

type TGetDiskNameListRes = IMQTTRes<{ disk_infos: IDiskNameInfo[] }>

// 获取磁盘名称映射
export function getDiskNameList (): Promise<TGetDiskNameListRes> {
  return sendMQTTMessage<TGetDiskNameListRes>('xl_gx', 'get_disk_info_from_device', {
  }).then(parseMqttResult)
}

// 修改磁盘名称
export function setDiskName (renameList: IDiskNameInfo[]) {
  return sendMQTTMessage('xl_gx', 'set_disk_info_to_device', {
    disk_infos: renameList,
  })
    .then(parseMqttResult)
}

export async function getSmbStatus () {
  return sendMQTTMessage<ISmbStatus>('xl_gx', 'get_status')
    .then(parseMqttResult)
}

export async function turnOnSmbService () {
  return sendMQTTMessage('xl_gx', 'start')
    .then(parseMqttResult)
}

export async function turnOffSmbService () {
  return sendMQTTMessage('xl_gx', 'stop')
    .then(parseMqttResult)
}

export async function enableAutoRunSmb () {
  return sendMQTTMessage('xl_gx', 'enable')
    .then(parseMqttResult)
}

export async function disableAutoRunSmb () {
  return sendMQTTMessage('xl_gx', 'disable')
    .then(parseMqttResult)
}

export async function getSmbConfig (): Promise<ISmbConfig> {
  return sendMQTTMessage<IMQTTRes<{ config: ISmbConfig }>>('xl_gx', 'get_config')
    .then(data => {
      const res = parseMqttResult<{ config: ISmbConfig }>(data)
      if (!res.result) throw new Error('未找到共享配置')
      return res.result.config
    })
}

/** set_config参数config必须为完整的配置（不支持部分更新） */
export async function updateSmbConfig (config: ISmbConfig): Promise<ISmbConfig> {
  return sendMQTTMessage('xl_gx', 'set_config', { config }).then(() => {
    return config
  })
}

/** 获取Smb匿名访问配置，返回是否允许匿名访问 */
export async function getSmbAccessibilityConfig () {
  return getSmbConfig().then(config => {
    console.log('[SMB配置]:', JSON.stringify(config))
    const { public: isPublic, users } = config
    const account = users.find(user => user.username !== 'hezi')
    return { isPublic, account }
  })
}

export async function setSmbAccessibilityConfig (isPublic: boolean) {
  return getSmbConfig().then(config => {
    const _config = { ...config, public: isPublic }
    return updateSmbConfig(_config)
  })
}

/** 新增/修改/删除 Smb非匿名访问时的账户信息(username和password同时为空时代表删除账户信息) */
export async function setSambaAccount (user: Pick<ISambaUser, 'username' | 'password'>) {
  return getSmbConfig().then(config => {
    const { users } = config
    const account: ISambaUser = { disabled: false, ...user }
    const targetIndex = users.findIndex(user => user.username !== 'hezi')
    if (targetIndex > -1) {
      if (account.username && account.password) {
        users.splice(targetIndex, 1, account)
      } else if (!account.username && !account.password) {
        users.splice(targetIndex, 1)
      } else {
        throw new Error('账号或密码不能为空')
      }
    } else {
      users.push(account)
    }

    const _config = { ...config, users }
    return updateSmbConfig(_config).then(config => {
      const { users } = config
      return users.find(user => user.username !== 'hezi')
    })
  })
}